import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import React, { ComponentProps } from 'react'
import { AnimationWrapper, EmptyStateRoot } from './EmptyState.styles'

type EmptyStateOwnProps = ComponentProps<typeof EmptyStateRoot>
export type EmptyStateProps = EmptyStateOwnProps & {
  animationUrl: string
  description: string
}

export const EmptyState = ({ animationUrl, description }: EmptyStateProps) => {
  return (
    <EmptyStateRoot>
      <Stack direction="column" alignItems="center" gap="3">
        <AnimationWrapper>
          <object type="image/svg+xml" data={animationUrl} aria-label={description} aria-hidden />
        </AnimationWrapper>
        <Text size={{ '@initial': 'h5', '@bp2': 'h4' }} color="accent-black" weight="bold">
          {description}
        </Text>
      </Stack>
    </EmptyStateRoot>
  )
}

EmptyState.displayName = 'EmptyState'
